
(function () {
    var etsScLoadJs = function (url, callback) {

        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        } else {
            script.onload = function () {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var etsScJavascript = function ($) {
        var etsSc = {
            getParameterByName: function (name, url) {
                url = url || window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            execSmartSelector: function (el){
                var $el = $(el);
                if( $el.attr('class') && $el.attr('class').indexOf('ets') != -1 || $('.'+$el.attr('class')).length > 1){
                    return false;
                }

                if($el.attr('id') && $el.attr('id').indexOf('ets') != -1 || $('#'+$el.attr('id')).length > 1){
                    return false;
                }

                if ( !$el.attr('class') && !$el.attr('id') )
                    return false;
                $('.ets-sc-ss-box-recommend').remove();
                if (($el.prev().length && $el.next().length) || $el.is('span') || $el.is('strong') || $el.is('i') || $el.is('image') || $el.width() < 250){
                    $el.addClass('ets-sc-ss-invalid');
                }
                else{
                    if ($el.prev().length){
                        $el.after(etsSc.renderBoxSmartSelector());
                    }
                    else{
                        $el.before(etsSc.renderBoxSmartSelector());
                    }
                }
            },
            clearSmartSelector: function (el){
                var $el = $(el);
                $('.ets-sc-ss-box-recommend').remove();
                $el.removeClass('ets-sc-ss-invalid');
                $el.removeClass('ets-sc-ss-ok');
            },
            renderBoxSmartSelector: function (){
                return '<div class="ets-sc-ss-box-recommend">Insert here</div>';
            },
            generateQuerySelector:function(el) {
                if (el.tagName.toLowerCase() == "html")
                    return "html";
                var idEl = el.getAttribute('id');
                if (idEl){
                    return '#'+idEl;
                }
                var str = el.tagName.toLowerCase();

                if (el.className) {
                    var classes = el.className.split(/\s+/);
                    for (var i = 0; i < classes.length; i++) {
                        if(classes[i].indexOf('ets-sc-ss-ok') === -1){
                            if ($('.'+classes[i]).length == 1){
                                return '.'+classes[i];
                            }
                            return '.'+classes[i];
                        }
                    }
                }
                return this.generateQuerySelector(el.parentNode) + " > " + str;
            }

        };

        function etsAddStyle(styles) {

            /* Create style element */
            var css = document.createElement('style');
            css.type = 'text/css';

            if (css.styleSheet)
                css.styleSheet.cssText = styles;
            else
                css.appendChild(document.createTextNode(styles));

            /* Append style to the head element */
            document.getElementsByTagName("head")[0].appendChild(css);
        }

        function EtsAddContentPro(el, options){
            var that = this;
            // Shared variables:
            that.element = el;

            that.lanAdd = 1;
            that.timer = null;
            that.setOptions(options);
            that.proCessAdd();

        }
        EtsAddContentPro.prototype = {
            setOptions: function (suppliedOptions) {
                var that = this,
                    options = $.extend({}, that.options, suppliedOptions);
                this.options = options;
            },
            proCessAdd : function (){
                var that = this;
                if (that.timer){
                    clearTimeout(that.timer);
                }
                that.el = $(that.options.idClass);
                if (that.options.displayType =='float' ){
                    $('body').append($(that.options.contentChart));
                    $('body').append($(that.options.buttonChart));
                }else if (that.el.length){
                    if (that.options.displayType=='button'){
                        $('body').append($(that.options.contentChart));
                    }
                    if (that.options.position == 'above'){

                        if(that.options.displayType =='block'){
                            that.el.before($(that.options.contentChart));

                        }else if(that.options.displayType =='button'){
                            that.el.before($(that.options.buttonChart));
                        }
                    }else{
                        if(that.options.displayType =='block'){
                            that.el.after($(that.options.contentChart));
                        } else if(that.options.displayType =='button'){
                            that.el.after($(that.options.buttonChart));
                        }
                    }
                }else if (that.lanAdd < 6){

                    that.timer = setTimeout(function () {
                        that.lanAdd = that.lanAdd +1;
                        that.proCessAdd();
                    },1000);
                }
            }
        };
        // Create chainable jQuery plugin:
        $.fn.devEtsAddContentPro = function (options, args) {

            var dataKey = 'etsaddcontentpro';
            // If function invoked without argument return
            // instance of the first matched element:
            if (!arguments.length) {
                return this.first().data(dataKey);
            }

            return this.each(function () {
                var inputElement = $(this),
                    instance = inputElement.data(dataKey);

                if (typeof options === 'string') {
                    if (instance && typeof instance[options] === 'function') {
                        instance[options](args);
                    }
                } else {
                    // If instance already exists, destroy it:
                    if (instance && instance.dispose) {
                        instance.dispose();
                    }
                    instance = new EtsAddContentPro(this, options);
                    inputElement.data(dataKey, instance);
                }
            });
        };
// Don't overwrite if it already exists
        if (!$.fn.autocomplete) {
            $.fn.autocomplete = $.fn.devEtsAddContentPro;
        }


        $(document).ready(function () {
            if (typeof ETS_SC_INIT == 'undefined' || !ETS_SC_INIT) {
                var etsCfCounterApp = 0;
                var etsCfIntervalApp = setInterval(function () {
                    if (typeof ETS_SC_INIT !== 'undefined' && ETS_SC_INIT) {
                        etsScInitApp();
                        clearInterval(etsCfIntervalApp);
                    }
                    etsCfCounterApp += 200;
                    if (etsCfCounterApp >= 5000) {
                        clearInterval(etsCfIntervalApp);
                    }
                }, 200);
            } else {
                etsScInitApp();
            }
        });
        function etsScInitApp() {
            var etsScSmartSelector = etsSc.getParameterByName('etsScSmartSelector');
            var itemCurrentSelect = null;
            if (etsScSmartSelector == '1'){
                $(document).on('mousemove', function (event){
                    event.preventDefault();
                    if ($(event.target).hasClass('ets-sc-ss-box-recommend')){
                        return false;
                    }
                    if (itemCurrentSelect && !$(itemCurrentSelect).is($(event.target))){
                        etsSc.clearSmartSelector(itemCurrentSelect);
                    }
                    itemCurrentSelect = event.target;
                    etsSc.execSmartSelector(event.target);
                });

                $(document).on('click', '.ets-sc-ss-box-recommend', function (){
                    if (!itemCurrentSelect){
                        return false;
                    }
                    var selectorIdClass = etsSc.generateQuerySelector(itemCurrentSelect);

                    if (selectorIdClass){
                        if (confirm('Are you want to choose: '+selectorIdClass)){
                            window.opener.postMessage({selector: selectorIdClass, 'ets_sc_app': 1}, '*');
                            window.close();
                        }
                    }
                    else{
                        alert('Can not get class or id of this element. Please choose another element');
                    }
                });
            }
            if (etsScSmartSelector != '1'){
                if (typeof ets_sc_product !=="undefined"){
                    var idProduct = ets_sc_product;

                    if (typeof ETS_CONFIG_CHART !== "undefined" && ETS_CONFIG_CHART.length){
                        for (const i in ETS_CONFIG_CHART){
                            if (typeof ETS_CONFIG_CHART[i]['product'][idProduct] !== "undefined"){
                                $('body').devEtsAddContentPro({
                                    buttonChart        : ETS_CONFIG_CHART[i]['content'].buttonChart,
                                    contentChart        : ETS_CONFIG_CHART[i]['content'].content,
                                    position        : ETS_CONFIG_CHART[i]['content'].position,
                                    displayType        : ETS_CONFIG_CHART[i]['content'].displayType,
                                    idClass : ETS_CONFIG_CHART[i]['content'].idClass
                                });
                                etsAddStyle(ETS_CONFIG_CHART[i]['css']);
                            }
                        }
                    }


                    $(document).on('click','.ets_button_chart',function(){
                        var self = $(this);
                        var id = self.attr('data-id');
                        $('body').find('#popup_sc_'+id).first().addClass('active');
                    });

                    $(document).on('click','.ets_sc_popup_overlay',function(){
                        $(this).closest('.ets_sc_wrap_popup').first().removeClass('active');
                    });

                    $(document).on('click','.btn_close_popup',function(){
                        $(this).closest('.ets_sc_wrap_popup').first().removeClass('active');
                    });

                    var ETS_SC_JS = function ETS_SC_JS() {
                        var self =this;
                    }

                    ETS_SC_JS.prototype.init = function(){
                        var _that = this;
                        _that.tabs();
                        _that.accordion();
                    }

                    ETS_SC_JS.prototype.tabs = function(){
                        $(document).on('click','.ets_header_tab li',function(event){
                            event.stopPropagation();
                            const self = $(this);
                            if(self.hasClass('active')){
                                return;
                            }
                            const dataIndex = self.attr('data-index');
                            self.siblings().removeClass('active');
                            self.addClass('active');
                            const ets_wrap_tab_content = self.closest('.ets_wrap_tab_content').first();
                            ets_wrap_tab_content.find('.ets_tab_pane.'+dataIndex).addClass('active').siblings().removeClass('active');
                            event.preventDefault();
                        });
                    };

                    ETS_SC_JS.prototype.accordion = function(){
                        $(document).on('click','.ets_accordion_header',function(event){
                            event.stopPropagation();
                            const self = $(this),
                                wrap_acros = self.closest('.ets_accordion_section').first();
                            if (wrap_acros.hasClass('open')){
                                wrap_acros.removeClass('open');
                            }else{
                                if(self.hasClass('closeOther')){
                                    wrap_acros.addClass('open').siblings().removeClass('open');
                                }else{
                                    wrap_acros.addClass('open');
                                }

                            }
                        });
                    };

                    var ets_ec_js = new ETS_SC_JS();
                    ets_ec_js.init();
                }
            }

        }
    };


    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        etsScLoadJs('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
            jQuery191 = jQuery.noConflict(true);
            try {
                etsScJavascript(jQuery191);
            } catch (e) {
                console.log(e.message)
            }
        });
    } else {
        try {
            etsScJavascript(jQuery);
        } catch (e) {
            console.log(e.message)
        }
    }

})();
//
